import { useNavigate } from '@tanstack/react-router';
import { Button, useShortcut } from '@wodi/ui';

import { setRegistrationPrefill } from './prefill.ts';

/**
 * "Register new patient", offered only once a search has found nobody (DESIGN.md §8), with
 * Alt+N while it is on screen. The search text pre-fills the form through memory, never
 * the address.
 */
export function RegisterNewPatientButton({
  searchText,
  onBeforeNavigate,
}: {
  searchText: string;
  onBeforeNavigate?: () => void;
}) {
  const navigate = useNavigate();
  const go = () => {
    setRegistrationPrefill(searchText);
    onBeforeNavigate?.();
    void navigate({ to: '/patients/new' });
  };
  useShortcut('alt+n', go, { allowInFields: true, description: 'Register new patient' });
  return (
    <Button variant="primary" onPress={go} aria-keyshortcuts="Alt+N">
      Register new patient
    </Button>
  );
}
